import React, {
  createContext,
  useState,
  useCallback,
  useContext,
  useEffect,
} from "react";
import axios from "../axiosConfig";
import Spinner from "../components/ui/Spinner";
import { userLogin, varifyToken } from "../services/auth/auth.service";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);
// Add useAuth hook
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async ({ email, password }) => {
    try {
      const res = await userLogin({ email, password });
      if (res?.status === 200) {
        const { accessToken, data, message, refreshToken } = res.data;
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        setUser({ ...data, role: "Admin" });
      }

      return res;
    } catch (error) {}
  };

  const logout = async () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = window.location.origin + "/login";
  };

  const checkAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        setLoading(false);
        return;
      }
      const res = await varifyToken();
      if (res?.data?.status === 200) {
        setUser({ ...res?.data?.data, role: "Admin" });
      } else {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = window.location.origin + "/login";
        setLoading(false);
      }
    } catch (error) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.href = window.location.origin + "/login";
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, []);

  // Call checkAuth when the provider mounts
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const resetPassword = async (email) => {
    const response = await axios.post("/auth/reset-password", { email });
    return response.data;
  };

  const setPassword = async (token, password) => {
    const response = await axios.post("/auth/set-password", {
      token,
      password,
    });
    return response.data;
  };

  const value = {
    user,
    loading,
    login,
    logout,
    checkAuth,
    resetPassword,
    setPassword,
  };

  // Don't render children until the initial auth check is complete
  if (loading) {
    return <Spinner />;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
